import { isClerkAPIResponseError } from '@clerk/nextjs/errors';
import { type AuthFailure } from './auth.types';

export const authFailure = (failure: unknown): AuthFailure => {
  if (isClerkAPIResponseError(failure)) {
    const first = failure.errors[0];
    return { code: first?.code, message: first?.longMessage || first?.message || 'Unable to continue. Please try again.' };
  }
  if (failure instanceof Error) {
    if (failure.cause) {
      return authFailure(failure.cause);
    }
    if ('code' in failure) {
      const detail = failure as Error & { code: string; longMessage?: string };
      return { code: detail.code, message: detail.longMessage || 'Unable to continue. Please try again.' };
    }
    return { message: failure.message };
  }
  return { message: 'Unable to continue. Please try again.' };
};

export const checkAuthResult = (result: { error: unknown }) => {
  if (result.error) {
    throw result.error;
  }
};
